// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__TTtyq","dragIcon":"Choice_dragIcon__1Zp8V","left":"Choice_left__btfM_","input":"Choice_input__3k-GJ"};